import type { ConversationWithMessages } from '../types';
import type { DispatchedTurn } from './dispatched-turn';

export const DISPATCH_GRACE_MS = 10_000;
export const RECOVERY_POLL_LIMIT_MS = 10 * 60_000;
export type ConversationRecovery =
  | 'running'
  | 'checking'
  | 'unavailable'
  | 'interrupted'
  | 'refresh'
  | null;

export function hasSavedDispatchedTurn(
  conversation: ConversationWithMessages,
  receipt: DispatchedTurn
): boolean {
  // The API assigns different IDs when it atomically saves the message pair.
  return (
    conversation.messages.filter((message) => message.role === 'user').length >
    receipt.previousUserMessages
  );
}

export function conversationRecovery(
  conversation: ConversationWithMessages | undefined,
  receipt: DispatchedTurn | null,
  deadline: number,
  now = Date.now()
): ConversationRecovery {
  if (!conversation) return null;
  if (conversation.turnStatus === 'unavailable') return 'unavailable';
  if (conversation.turnStatus === 'running') {
    return now < deadline ? 'running' : 'refresh';
  }
  if (receipt && !hasSavedDispatchedTurn(conversation, receipt)) {
    return now - receipt.at < DISPATCH_GRACE_MS ? 'checking' : 'interrupted';
  }
  return null;
}

/** Confirmed idle without a saved turn permits an explicit new message. */
export function blocksConversationSend(
  recovery: ConversationRecovery | undefined
): boolean {
  return Boolean(recovery && recovery !== 'interrupted');
}
